import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Badge!=!/vercel/path0/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/ehphuong/components/About/Banner/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/ehphuong/components/About/Contact/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/ehphuong/components/About/Intro/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ehphuong/components/common/Divider/Divider.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ehphuong/components/About/Skills/Skills.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ehphuong/components/About/Support/Support.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/ehphuong/components/common/Footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/ehphuong/components/common/Header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/ehphuong/components/common/Icons/CSSIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/ehphuong/components/common/Image/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/ehphuong/providers/LocomotiveProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/ehphuong/providers/WrapperProvider.tsx");
